(function () {
  'use strict';

  angular
    .module('app.cart.validation', [])

    .directive('cartValidation', function () {
      return {
        restrict: 'A',
        bindToController: {
          device: '<',
          step: '<'
        },
        controllerAs: 'cartCtrl',
        /* @ngInject */
        controller: ["$scope", "$rootScope", "$element", "$location", "$templateCache", "AppService", "CartService", "AccountService", "HttpService", "ModalService", "RoutesService", function ($scope, $rootScope, $element, $location, $templateCache, AppService, CartService, AccountService, HttpService, ModalService, RoutesService) {
          var ctrl = this;
          ctrl.NextEnabled = false;

          var _routes = RoutesService.get();
          ctrl.nextStep = '/' + _routes.CartPaymentAction.url;
          ctrl.linkShipping = '/' + _routes.CartShipping.url;
          ctrl.linkPayment = '/' + _routes.CartPayment.url;

          // Translate
          var tplTranslate = {};
          $element.children('.translate').children().each(function () {
            var $this = $(this);
            tplTranslate[$this.attr('key')] = $this.html();
          });

          ctrl.$onInit = function () {
            getValidationInfos(true);
            ctrl.nextStep = '/' + _routes.CartPaymentAction.url + (ctrl.device.mobile ? '?mobile=true' : '');
          };

          // Cart Aside
          ctrl.toggleCart = function () {
            CartService.toggleCart(ctrl);
          };
          ctrl.toggleUpdate = function (model) {
            CartService.toggleUpdate(ctrl, model);
          };
          ctrl.submitCode = function (event) {
            if (String(ctrl.formCode.data.code) === '') return;
            $(event.target).find('.form-control').blur();
            CartService.submitCode(ctrl);
          };
          ctrl.cancelCode = function (code) {
            CartService.cancelCode(ctrl, code);
          };
          ctrl.addLoyaltyPoint = function () {
            CartService.addLoyaltyPoint(ctrl);
          };
          ctrl.cancelLoyaltyPoint = function () {
            CartService.cancelLoyaltyPoint(ctrl);
          };
          ctrl.useCredit = function (id) {
            CartService.useCredit(ctrl, id);
          };
          ctrl.cancelCredit = function (id) {
            CartService.cancelCredit(ctrl, id);
          };
          ctrl.cancelGiftCard = function (code) {
            CartService.cancelGiftCard(ctrl, code);
          };
          // End Cart Aside

          ctrl.changeShippingAddress = function (item) {
            if (item.PickUp) {
              $location.path(ctrl.linkShipping);
            } else {
              $rootScope.$broadcast('showPageLoader', true);
              AccountService.getShippingAddresses()
                .then(function (results) {
                  AppService.getParams()
                    .then(function (params) {
                      var addresses = [
                        {
                          IDCard: params.Visitor.IDCard,
                          FullName: params.Visitor.FullName,
                          Address: params.Visitor.Address,
                          AddressApartment: params.Visitor.AddressApartment,
                          AddressBuilding: params.Visitor.AddressBuilding,
                          AddressLocality: params.Visitor.AddressLocality,
                          PostCode: params.Visitor.PostCode,
                          City: params.Visitor.City,
                          Country: {
                            Designation: params.Visitor.Country.Designation
                          },
                          Phone: params.Visitor.Phone,
                          MobilePhone: params.Visitor.MobilePhone
                        }
                      ];
                      addresses = addresses.concat(_.filter(results.addresses, { IDCardType: 7 }));
                      addresses = _.filter(addresses, function (address) {
                        return address.IDCard !== params.Cart.IDShippingCard;
                      });
                      ModalService.show(
                        '/Template/Cart/ModalSetShippingAddress',
                        {
                          device: ctrl.device,
                          addresses: addresses,
                          titles: results.titles,
                          countries: results.countries,
                          country: params.Visitor.Country,
                          action: function (card) {
                            setShippingAddress(card);
                          },
                          Phone: params.Visitor.Phone,
                          MobilePhone: params.Visitor.MobilePhone
                        },
                        null,
                        'modalSetShippingAddressCtrl'
                      );
                      $rootScope.$broadcast('showPageLoader', false);
                    });
                })
                .catch(function (error) {
                  console.error(error);
                });
            }
          };
          ctrl.changeInvoiceAddress = function () {
            var unwatch = $scope.$on('invoiceUpdate', function () {
              unwatch();
              ModalService.close();
              getValidationInfos();
            });

            $templateCache.remove('/ModalAccountUpdate?view=ModalAccountUpdate');
            ModalService.show(
              '/ModalAccountUpdate?view=ModalAccountUpdate',
              {},
              null,
              'modalAccountUpdateController',
              'accountCtrl'
            );
          };

          ctrl.openCgv = function () {
            ModalService.show(
              '/Template/Modal/ModalCgv',
              {}
            );
          };

          ctrl.gotoPaymentPage = function () {
            if (ctrl.NextEnabled) {
              $rootScope.$broadcast('showPageLoader', true);
            }
          };

          // Functions

          $scope.$on('cartUpdate', function () {
            getCart();
          });

          $scope.$watch('cartCtrl.NextEnabled', function (value) {
            ctrl.NextTooltip = value ? '' : tplTranslate.AcceptCgv;
          });

          // Functions

          function getCart() {
              AppService.getParams()
              .then(function (data) {
                CartService.update(ctrl, data, true);
                CartService.updateStepsCart(ctrl);
              })
              .catch(function (error) {
                console.error(error);
              });
          }

          function getValidationInfos(loadCart) {
            AppService.getParams()
              .then(function (params) {
                ctrl.shipping = params.Cart.Shipping;
                ctrl.payment = params.Cart.PaymentMethod;

                if (loadCart) getCart();


                ctrl.invoiceAddress = {
                    Name: params.Visitor.BillingCard != null ? params.Visitor.BillingCard.FullName : params.Visitor.FullName,
                    AddressLine1: params.Visitor.BillingCard != null ? params.Visitor.BillingCard.Address : params.Visitor.Address,
                    AddressLine2: params.Visitor.BillingCard != null ? params.Visitor.BillingCard.AddressLocality : params.Visitor.AddressLocality,
                    Apartment: params.Visitor.BillingCard != null ? params.Visitor.BillingCard.AddressApartment : params.Visitor.AddressApartment,
                    Building: params.Visitor.BillingCard != null ? params.Visitor.BillingCard.AddressBuilding : params.Visitor.AddressBuilding,
                    Complement: null,
                    PostCode: params.Visitor.BillingCard != null ? params.Visitor.BillingCard.PostCode : params.Visitor.PostCode,
                    City: params.Visitor.BillingCard != null ? params.Visitor.BillingCard.City : params.Visitor.City,
                    Country: params.Visitor.BillingCard != null ? params.Visitor.BillingCard.Country.Designation : params.Visitor.Country.Designation
                };
                
             
                if (ctrl.shipping) {
                  ctrl.shippingAddress = {
                    Name: ctrl.shipping.Address.Name,
                    AddressLine1: ctrl.shipping.Address.AddressLine1,
                    AddressLine2: ctrl.shipping.Address.AddressLine2,
                    Apartment: ctrl.shipping.Address.Apartment,
                    Building: ctrl.shipping.Address.Building,
                    Complement: ctrl.shipping.Address.Complement,
                    PostCode: ctrl.shipping.Address.PostCode,
                    City: ctrl.shipping.Address.City,
                    Country: ctrl.shipping.Address.Country
                  };
                  if (ctrl.shipping.Key !== 'ENLEVEMENT') {
                    ctrl.shipping.btnAction = ctrl.shipping.PickUp ? tplTranslate.ChoisirUnAutrePoint : tplTranslate.ChoisirUneAutreAdresse;
                    ctrl.shipping.titleShippingAddress = ctrl.shipping.PickUp ? tplTranslate.PointRetrait : tplTranslate.AdresseLivraison;
                  } else {
                    ctrl.shipping.btnAction = '';
                    ctrl.shipping.titleShippingAddress = tplTranslate.EnlevementMagasin;
                  }
                }

                ctrl.invoiceAddressIsEqual = _.isEqual(ctrl.shippingAddress, ctrl.invoiceAddress);
                ctrl.invoiceAddressIsEqual = ctrl.isNumericCart ? false : ctrl.invoiceAddressIsEqual;
                if (ctrl.shipping) ctrl.shipping.imgSrc = '/img/shipping/' + _.camelCase(ctrl.shipping.Key) + '.png';
                if (ctrl.payment) ctrl.payment.imgSrc = '/img/payment/' + _.camelCase(ctrl.payment.Key) + '.png';

                ctrl.active = true;
              })
              .catch(function (error) {
                console.error(error);
              });
          }

          function setShippingAddress(card) {
            $rootScope.$broadcast('showPageLoader', true);
            HttpService.post({
              url: '/Shipping/SetShippingAddress',
              data: card.IDCard
            })
            .then(function (response) {
              if (response.status === 'OK') {
                CartService.update(ctrl, response.results);

                if (!ctrl.cart.Shipping) {
                  $location.path('/' + _routes.CartShipping.url);
                  return;
                }

                ctrl.shipping = ctrl.cart.Shipping;
                ctrl.shipping.btnAction = tplTranslate.ChoisirUneAutreAdresse;
                ctrl.shipping.titleShippingAddress = tplTranslate.AdresseLivraison;
                getValidationInfos(false);
                $rootScope.$broadcast('showPageLoader', false);
              }
            })
            .catch(function (error) {
              console.error(error);
            });
          }

        }]
      };
    });

})();
